import { render, staticRenderFns } from "./MultiFileUploader.vue?vue&type=template&id=70ab300d&scoped=true"
import script from "./MultiFileUploader.vue?vue&type=script&lang=js"
export * from "./MultiFileUploader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ab300d",
  null
  
)

export default component.exports